import { useMemo } from "react";
import { renderLandingHTML } from "@farmacias/template";
import type { Farmacia } from "@farmacias/schema";

const BASE_DOMAIN = "sites.oniochat.com.br";

/** Preview em tempo real — exatamente o mesmo render do Cloud Run. */
export function Preview({ farmacia }: { farmacia: Farmacia }) {
  const html = useMemo(() => {
    try {
      return renderLandingHTML({
        farmacia,
        baseUrl: `https://${farmacia.slug}.${BASE_DOMAIN}`,
      });
    } catch (e) {
      return `<pre style="padding:16px;font:14px system-ui;color:#b91c1c">${
        e instanceof Error ? e.message : "erro no preview"
      }</pre>`;
    }
  }, [farmacia]);

  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
      <div className="border-b border-slate-100 px-3 py-1.5 text-xs text-slate-500">
        Pré-visualização · {farmacia.slug}.{BASE_DOMAIN}
      </div>
      <iframe
        title="Pré-visualização da landing"
        srcDoc={html}
        className="h-[640px] w-full bg-white"
        sandbox="allow-same-origin"
      />
    </div>
  );
}
